<template>
  <div class="account flex">
    <i v-if="item.success" class="el-icon-success" style="color: #42b983"></i>
    <i v-else class="el-icon-warning" style="color: #f56c6c"></i>
    <div class="account-item flex flex_align-items flex_space-between">
      <div class="account-item-left">
        <h2 class="title">{{item.name}}</h2>
        <p>{{item.desc}}</p>
      </div>

      <div class="account-item-right pointer" @click="handleRouter(item.url,item.index)">
        <span>{{item.button}}</span>
      </div>

    </div>
  </div>
</template>

<script>
export default {
  name: "certification-item",
  props: {
    item: Object,
  },
  methods: {
    handleRouter(url, index) {
      this.$router.replace({path: url})

    }
  }
}
</script>

<style scoped lang="scss">
.account {
  padding: $spacing-row-base 0;
  border-bottom: 1px solid #f3f5f6;

  i {
    font-size: 25px;
  }
  &-item {
    margin-left: $spacing-cols-sm;
    width: 100%;

    &-left {
      h2 {
        font-size: $font-size-lg;
      }

      p {
        font-size: $font-size-base;
        color: #9199a1;
        line-height: 30px;
      }
    }


    &-right {
      color: #206aff;
    }
  }
}
</style>
